module.exports = __webpack_public_path__ + "img/Feather.336114b4.svg";